export default __webpack_public_path__ + "9431c75d79baa71449c8fe91b617a7f9.png";